import { createFileRoute } from '@tanstack/react-router';
import { ContentHeader, ConceptCard, ConceptCardGrid } from "@/components/content";

export const Route = createFileRoute('/concepts/')({
  component: ConceptsPage,
  head: () => ({
    meta: [
      { title: 'Concepts | Matricks' },
      { name: 'description', content: 'Learn about API gateways, AI agents, security, and integration concepts. Educational resources to help you understand modern enterprise architecture.' },
    ],
  }),
});

const concepts = [
  {
    title: "What is an API Gateway?",
    description:
      "Learn how API gateways act as the front door for your APIs, providing routing, security, and management capabilities.",
    href: "/concepts/api-gateway",
    iconName: "Router",
  },
  {
    title: "API Management Explained",
    description:
      "Understand the full lifecycle of API management, from design and development to deployment and monitoring.",
    href: "/concepts/api-management",
    iconName: "Globe",
  },
  {
    title: "What are AI Agents?",
    description:
      "Discover how AI agents can automate complex tasks, make decisions, and interact with external systems autonomously.",
    href: "/concepts/ai-agents",
    iconName: "Bot",
  },
  {
    title: "Zero-Trust Security",
    description:
      "Explore the zero-trust security model and how it protects your APIs and data in a modern threat landscape.",
    href: "/concepts/zero-trust-security",
    iconName: "Shield",
  },
  {
    title: "Workflow Automation",
    description:
      "Learn how workflow automation can streamline business processes and reduce manual work across your organization.",
    href: "/concepts/workflow-automation",
    iconName: "Workflow",
  },
  {
    title: "Webhooks Explained",
    description:
      "Understand how webhooks enable real-time event-driven communication between applications and services.",
    href: "/concepts/webhooks",
    iconName: "Webhook",
  },
  {
    title: "RBAC vs ABAC",
    description:
      "Compare role-based and attribute-based access control models to choose the right approach for your needs.",
    href: "/concepts/rbac-abac",
    iconName: "Lock",
  },
  {
    title: "Data Integration",
    description:
      "Explore strategies for connecting and synchronizing data across multiple systems and platforms.",
    href: "/concepts/data-integration",
    iconName: "Database",
  },
];

function ConceptsPage() {
  return (
    <div>
      <ContentHeader
        title="Learn the Fundamentals"
        description="Educational resources to help you understand modern enterprise architecture, API management, AI agents, and security concepts."
        breadcrumbs={[{ label: "Home", href: "/" }, { label: "Concepts" }]}
      />

      <ConceptCardGrid columns={2}>
        {concepts.map((concept) => (
          <ConceptCard
            key={concept.href}
            title={concept.title}
            description={concept.description}
            href={concept.href}
            iconName={concept.iconName}
          />
        ))}
      </ConceptCardGrid>
    </div>
  );
}
